import React, { useState, useEffect } from 'react';
import TrashIcon from '@rsuite/icons/Trash';
import ImageIcon from '@rsuite/icons/Image';
import EditIcon from '@rsuite/icons/Edit';
import globalIP from '../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import './style.css';
import {
  Input,
  Modal,
  IconButton,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Col,
  Form,
  FlexboxGrid,
  Container,
  SelectPicker,
  useToaster,
  Uploader,
  Message,
  Loader,
  Table,
  Button,
  InputNumber,
  InputPicker
} from 'rsuite';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { isValidURL, validateEmail, validateEmail2 } from '@/functions';
import ugr from '@/UGRoute';
interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    cmpnm: string;
    address: string;
    country: string;
    state: string;
    city: string;
    pin_no: 0;
    reg_type: string;
    org_type: string;
    faxno: 0;
    email_id: string;
    website: string;
    gstno: 0;
    cmpcd: string;
    madeby: 'Shantanu';
    Type: string;
    Bank_Detail: [
      {
        id: 3;
        bankName: string;
        branchName: string;
        ifsc_code: string;
        accountno: 0;
        bankaddress: string;
        swiftcode: string;
        cmpcd: null;
      }
    ];
    ContactDetail: [
      {
        Name: string;
        mobileno: 0;
        email: string;
      }
    ];
    Logo: {
      data: {
        attributes: {
          url: string;
        };
      };
    };
  };
}

const regtype = [
  'Manufacturer',
  'Importer',
  'Dealer',
  'Exporter',
  'Reseller',
  'Manufacturer & Exporter'
].map(item => ({ label: item, value: item }));
const orgtype = [
  'Individual/Proprietorship',
  'Partnership',
  'Private Ltd.',
  'Public Ltd.',
  'LLP'
].map(item => ({ label: item, value: item }));
const type = ['International', 'Domestic'].map(item => ({ label: item, value: item }));
const { HeaderCell, Cell } = Table;
function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}
const CompanyMaster = () => {
  const ip = globalIP;
  const toaster = useToaster();
  const [uploading, setUploading] = useState(false);
  const [fileInfo, setFileInfo] = useState(null);

  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  useEffect(() => {
    fetchDatacountry();
  }, []);
  const fetchDatacountry = async () => {
    try {
      const response = await fetch(`${ip}/api/countries?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/countries?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.countrynm,
          value: item.attributes.countrynm
        }));
        allData.push(...processedData);
      }
      setCountry(allData);
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  useEffect(() => {
    if (selectedCountry) {
      fetchStates();
    }
  }, [selectedCountry]);
  const fetchStates = async () => {
    try {
      const response = await fetch(
        `${ip}/api/states?&filters[countrynm][$eq]=${selectedCountry}&pagination[page]=1`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/states?populate=*&filters[countrynm][$eq]=${selectedCountry}&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.statenm,
          value: item.attributes.statenm
        }));
        allData.push(...processedData);
      }

      setStates(allData);
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };
  const [city, setCity] = useState([]);
  useEffect(() => {
    if (selectedState) {
      fetchCity();
    }
  }, [selectedState]);
  const fetchCity = async () => {
    try {
      const response = await fetch(
        `${ip}/api/cities?populate=*&filters[statenm][$eq]=${selectedState}`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/cities?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.citynm,
          value: item.attributes.citynm
        }));
        allData.push(...processedData);
      }

      setCity(allData);
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  // Api add data start
  const [data, setData] = useState({
    cmpnm: '',
    address: '',
    country: '',
    state: '',
    city: '',
    pin_no: '0',
    reg_type: '',
    org_type: '',
    faxno: '0',
    email_id: '',
    contactno: '',
    website: '',
    gstno: '',
    cmpcd: 'CMP1',
    madeby: 'Shantanu',
    GLink: '',
    tradeFairLink: "",
    Type: '',
    Bank_Detail: [
      {
        bankName: '',
        branchName: '',
        ifsc_code: '',
        accountno: '',
        bankaddress: '',
        swiftcode: ''
      }
    ],
    ContactDetail: [
      {
        Name: '',
        mobileno: '',
        email: ''
      }
    ],
    Logo: null
  });

  const url = `${ip}/api/company-details`;
  const submit = e => {
    // console.log(data);
    if (data.cmpnm.trim() == '') {
      toaster2.push(message2, { placement: 'topCenter' });
    }
    if (data.email_id.trim()) {
      if (data.email_id.trim() == '') {
        toaster2.push(
          <Message showIcon type="error">
            Email is required
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!validateEmail2(data.email_id.trim())) {
        toaster2.push(
          <Message showIcon type="error">
            Please check Email.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
    }
    if (data.website.trim()) {
      if (data.website.trim() == '') {
        toaster2.push(
          <Message showIcon type="error">
            Website is required.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!isValidURL(data.website.trim())) {
        toaster2.push(
          <Message showIcon type="error">
            Please check website Url.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
    }
    if (data.contactno.trim()) {
      if (data.contactno.trim() == '') {
        toaster2.push(
          <Message showIcon type="error">
            Contact no is required.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!(data.contactno.trim().length <= 12)) {
        toaster2.push(
          <Message showIcon type="error">
            Please check our Contact no.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
    }
    if (rows.length > 0) {
      // if (rows.every(item => item.mobileno.trim() == '')) {
      //   const checkContactDetailscontact = rows.every(row => {
      //     return row.mobileno.trim().length <= 12;
      //   });
      //   if (checkContactDetailscontact) {
      //     toaster2.push(
      //       <Message showIcon type="error">
      //         Please check our Contact Details.
      //       </Message>,
      //       { placement: 'topCenter' }
      //     );
      //     return;
      //   }
      // }
      // if (rows.every(item => item.email.trim() == '')) {
      //   const checkContactDetailsMail = rows.every(row => {
      //     return validateEmail2(row.email.trim());
      //   });
      //   if (!checkContactDetailsMail) {
      //     toaster2.push(
      //       <Message showIcon type="error">
      //         Please check our Contact Details.
      //       </Message>,
      //       { placement: 'topCenter' }
      //     );
      //     return;
      //   }
      // }
    }
    e.preventDefault();
    const formData = new FormData();
    // Append rows data to the main data state
    const newData = { ...data };
    newData.ContactDetail = rows.map(row => ({
      Name: row.Name.trim(),
      mobileno: row.mobileno.trim(),
      email: row.email.trim()
    }));
    setData(newData);
    formData.append('data', JSON.stringify(data));
    formData.append('files.Logo', data.Logo);
    fetch(url, {
      method: 'POST',
      body: formData
    })
      .then(response => fetchData())
      .then(data => console.log(data))
      .catch(error => console.error(error));
    setData({
      cmpnm: '',
      address: '',
      country: '',
      state: '',
      city: '',
      pin_no: '',
      contactno: '',
      reg_type: '',
      org_type: '',
      faxno: '',
      email_id: '',
      website: '',
      gstno: '',
      cmpcd: 'CMP1',
      madeby: 'Shantanu',
      GLink: '',
      tradeFairLink: "",
      Type: '',
      Bank_Detail: [
        {
          bankName: '',
          branchName: '',
          ifsc_code: '',
          accountno: '',
          bankaddress: '',
          swiftcode: ''
        }
      ],
      ContactDetail: [
        {
          Name: '',
          mobileno: '',
          email: ''
        }
      ],
      Logo: null
    });
    setFileInfo(null);
    toaster1.push(message1, { placement: 'topCenter' });
  };
  const delet = id => {
    fetch(`${url}/${id}`, {
      method: 'DELETE'
    })
      .then(response => fetchData())
      .then(data => console.log(data))
      .catch(error => console.error(error));
  };
  const handleInputChange = (inputName, value, index) => {
    if (inputName === 'Bank_Detail') {
      setData(prevData => {
        const updatedBank_Detail = [...prevData.Bank_Detail];
        updatedBank_Detail[index] = {
          ...updatedBank_Detail[index],
          [value.name]: value.value
        };
        return {
          ...prevData,
          Bank_Detail: updatedBank_Detail
        };
      });
    } else if (inputName === 'country') {
      setSelectedCountry(value);
      setData({ ...data, [inputName]: value });
    } else if (inputName === 'state') {
      setSelectedState(value);
      setData({ ...data, [inputName]: value });
    } else {
      setData({ ...data, [inputName]: value });
    }
  };
  // console.log("DATA :", data)
  const handleImageUpload = fileList => {
    setData({
      ...data,
      Logo: fileList[0].blobFile
    });
  };
  const [data1, setData1] = useState<RowData[]>([]);
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  // console.log('editedData');
  // console.log(editedData);
  const [progress, setProgress] = useState(0);
  // console.log('data1');
  // console.log(data1[0]?.attributes.Logo.data);
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    // console.log('data1', data1);
  }, [data1]);
  const fetchData = async () => {
    setProgress(30);
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    setProgress(60);
    const json = await response.json();
    setData1(json.data);
    setProgress(100);
  };
  const handleEditRow = rowData => {
    // console.log('Row data :', rowData)
    setModalOpen(true);
    setSelectedCountry(rowData.attributes.country);
    handleOpen('lg');
    setEditedRowIds(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedData(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    setData(prevData => ({
      ...prevData,
      ...rowData.attributes
    }));
    setRows([...rowData.attributes.ContactDetail]);
    setFileInfo(`${ip}${rowData.attributes.Logo.data.attributes.url}`)
    setCurrentlyEditingRowId(rowData.id);
  };
  const handleSaveRow = async (rowId: string) => {
    // console.log(data);
    // console.log('rowId', rowId);
    if (data.cmpnm.trim() == '') {
      toaster2.push(message2, { placement: 'topCenter' });
      return
    }
    if (data.email_id?.trim()) {
      if (data.email_id?.trim() == '') {
        toaster2.push(
          <Message showIcon type="error">
            Email is required
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!validateEmail2(data.email_id?.trim())) {
        toaster2.push(
          <Message showIcon type="error">
            Please check Email.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
    }
    if (data.website?.trim()) {
      if (data.website?.trim() == '') {
        toaster2.push(
          <Message showIcon type="error">
            Website is required.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!isValidURL(data.website?.trim())) {
        toaster2.push(
          <Message showIcon type="error">
            Please check website Url.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
    }
    if (data.contactno?.trim()) {
      if (data.contactno?.trim() == '') {
        toaster2.push(
          <Message showIcon type="error">
            Contact no is required.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!(data.contactno?.trim().length <= 12)) {
        toaster2.push(
          <Message showIcon type="error">
            Please check our Contact no.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
    }
    if (rows.length) {
      // if (rows.every(item => item.mobileno.trim() == '')) {
      //   const checkContactDetailscontact = rows.every(row => {
      //     return row.mobileno.trim().length <= 12;
      //   });
      //   if (checkContactDetailscontact) {
      //     toaster2.push(
      //       <Message showIcon type="error">
      //         Please check our Contact Details.
      //       </Message>,
      //       { placement: 'topCenter' }
      //     );
      //     return;
      //   }
      // }
      // if (rows.every(item => item.email.trim() == '')) {
      //   const checkContactDetailsMail = rows.every(row => {
      //     return validateEmail2(row.email.trim());
      //   });
      //   if (!checkContactDetailsMail) {
      //     toaster2.push(
      //       <Message showIcon type="error">
      //         Please check our Contact Details.
      //       </Message>,
      //       { placement: 'topCenter' }
      //     );
      //     return;
      //   }
      // }
    }
    const formData = new FormData();
    const { Logo, ...otherData } = data
    if (fileInfo === null) {
      formData.append('data', JSON.stringify(data));
      formData.append('files.Logo', data.Logo);

    }
    else {
      formData.append('data', JSON.stringify(otherData));
      formData.append('files.Logo', data.Logo);
    }
    // console.log('files.Logo', data.Logo)
    console.log('submit data1', data1);
    // return;
    const logoResponse = await fetch(`${ip}/api/company-details/${data1[0].id}`, {
      method: 'PUT',
      body: formData
    });

    setData({
      cmpnm: '',
      address: '',
      country: '',
      state: '',
      city: '',
      pin_no: '',
      contactno: '',
      reg_type: '',
      org_type: '',
      faxno: '',
      email_id: '',
      website: '',
      gstno: '',
      cmpcd: 'CMP1',
      madeby: 'Shantanu',
      GLink: '',
      tradeFairLink:"",
      Type: '',
      Bank_Detail: [
        {
          bankName: '',
          branchName: '',
          ifsc_code: '',
          accountno: '',
          bankaddress: '',
          swiftcode: ''
        }
      ],
      ContactDetail: [
        {
          Name: '',
          mobileno: '',
          email: ''
        }
      ],
      Logo: null
    });
    setRows([{ Name: '', mobileno: '', email: '' }])

    setFileInfo(null);
    setModalOpen(false)
    fetchData()
    toaster.push(
      <Message showIcon type="success">
        Updated Successfully
      </Message>,
      { placement: 'topEnd' }
    );
  };
  const handleInputChangeCommaster = (rowId, fieldName, value, index) => {
    if (
      fieldName === 'bankName' ||
      fieldName === 'branchName' ||
      fieldName === 'ifsc_code' ||
      fieldName === 'accountno' ||
      fieldName === 'bankaddress' ||
      fieldName === 'swiftcode'
    ) {
      setEditedData(prevData => ({
        ...prevData,
        [rowId]: {
          ...prevData[rowId],
          Bank_Detail: prevData[rowId]?.Bank_Detail?.map((bank, i) =>
            i === index ? { ...bank, [fieldName]: value } : bank
          )
        }
      }));
    } else if (fieldName === 'Name' || fieldName === 'mobileno' || fieldName === 'email') {
      setEditedData(prevData => ({
        ...prevData,
        [rowId]: {
          ...prevData[rowId],
          ContactDetail: prevData[rowId]?.ContactDetail?.map((cont, i) =>
            i === index ? { ...cont, [fieldName]: value } : cont
          )
        }
      }));
    } else if (fieldName === 'Logo') {
      setEditedData(prevData => ({
        ...prevData,
        [rowId]: {
          ...prevData[rowId],
          Logo: value // Set the new logo URL
        }
      }));
    } else if (fieldName === 'country') {
      setSelectedCountry(value); // Optional: separate state for country
      setEditedData(prevData => ({
        ...prevData,
        [rowId]: {
          ...prevData[rowId],
          country: value // Set the selected country in editedData
        }
      }));
    } else {
      setEditedData(prevData => ({
        ...prevData,
        [rowId]: {
          ...prevData[rowId],
          [fieldName]: value
        }
      }));
    }
  };
  const toaster1 = useToaster();
  const message1 = (
    <Message showIcon type="success" closable>
      Company Details Saved Successfully.
    </Message>
  );
  const toaster2 = useToaster();
  const message2 = (
    <Message showIcon type="error">
      Please fill the company details.
    </Message>
  );
  const [rows, setRows] = useState([{ Name: '', mobileno: '', email: '' }]);
  const handleAddRow = () => {
    setRows([...rows, { Name: '', mobileno: '', email: '' }]);
  };
  const handleDeleteRow1 = id => {
    setRows(rows.filter((_, index) => index != id));
    setData(prevData => ({
      ...prevData,
      ContactDetail: rows.filter((_, index) => index != id)
    }));
  };
  // const handleAddRowData = (name, value, index) => {
  //   setRows(prev => {
  //     const newState = [...prev];
  //     newState[index][name] = value.trim();
  //     return newState;
  //   });
  // };
  const handleAddRowData = (name, value, index) => {
    setRows(prev => {
      const newState = [...prev];
      // Conditionally trim based on the field name
      newState[index][name] = name === 'Name' ? value : value.trim();
      const newData = { ...data };
      newData.ContactDetail[index] = {
        ...newData.ContactDetail[index],
        [name]: name === 'Name' ? value : value.trim()
      };
      setData(newData);
      return newState;
    });
  };

  const [size, setSize] = useState();
  const handleOpen = value => {
    setSize(value);
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [currentlyEditingRowId, setCurrentlyEditingRowId] = useState(null);
  const [uploadImage, setUploadImage] = useState();
  const renderModalContent = () => {
    const rowData = data1.find(row => row.id === currentlyEditingRowId);

    // Ensure at least one empty ContactDetail and Bank_Detail row is present if not already existing
    const ensureAtLeastOneContactRow = () => {
      const contactRows = editedData[currentlyEditingRowId]?.ContactDetail;
      if (contactRows && contactRows.length > 0) {
        return contactRows;
      } else {
        // Initialize an empty contact row in editedData
        const newContactRow = [{ Name: '', mobileno: '', email: '' }];
        setEditedData(prevData => ({
          ...prevData,
          [currentlyEditingRowId]: {
            ...prevData[currentlyEditingRowId],
            ContactDetail: newContactRow
          }
        }));
        return newContactRow;
      }
    };

    const ensureAtLeastOneBankRow = () => {
      const bankRows = editedData[currentlyEditingRowId]?.Bank_Detail;
      if (bankRows && bankRows.length > 0) {
        return bankRows;
      } else {
        // Initialize an empty bank row in editedData
        const newBankRow = [
          {
            bankName: '',
            branchName: '',
            ifsc_code: '',
            accountno: '',
            bankaddress: '',
            swiftcode: ''
          }
        ];
        setEditedData(prevData => ({
          ...prevData,
          [currentlyEditingRowId]: {
            ...prevData[currentlyEditingRowId],
            Bank_Detail: newBankRow
          }
        }));
        return newBankRow;
      }
    };

    // Function to add a new contact row
    const addNewContact = () => {
      const newContact = { Name: '', mobileno: '', email: '', cmpcd: '' };
      handleInputChangeCommaster(
        currentlyEditingRowId,
        'ContactDetail',
        [...ensureAtLeastOneContactRow(), newContact],
        0
      );
    };

    // Function to add a new bank row
    const addNewBank = () => {
      const newBank = {
        bankName: '',
        branchName: '',
        ifsc_code: '',
        accountno: '',
        bankaddress: '',
        swiftcode: '',
        cmpcd: ''
      };
      handleInputChangeCommaster(
        currentlyEditingRowId,
        'Bank_Detail',
        [...ensureAtLeastOneBankRow(), newBank],
        0
      );
    };

    // Function to remove a contact row, but prevent removal if only one row is left
    const removeContactRow = index => {
      const currentContacts = ensureAtLeastOneContactRow();
      if (currentContacts.length > 1) {
        const updatedContacts = currentContacts.filter((_, i) => i !== index);
        handleInputChangeCommaster(currentlyEditingRowId, 'ContactDetail', updatedContacts, 0);
      }
    };

    // Function to remove a bank row, but prevent removal if only one row is left
    const removeBankRow = index => {
      const currentBanks = ensureAtLeastOneBankRow();
      if (currentBanks.length > 1) {
        const updatedBanks = currentBanks.filter((_, i) => i !== index);
        handleInputChangeCommaster(currentlyEditingRowId, 'Bank_Detail', updatedBanks, 0);
      }
    };

    // console.log("COMPANY DATA :",data)
    // console.log("UPDATED DATA :",editedData)

    return (
      <Modal open={false} onClose={() => setModalOpen(false)} size={size} backdrop="static">
        <Modal.Header>
          <Modal.Title>
            <b>Update Details</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Divider>Company Update</Divider>
          {rowData && (
            <>
              <Form>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Stack justifyContent="center">
                    <div
                      style={{
                        width: '200px',
                        height: '200px',
                        borderRadius: '10px',
                        overflow: 'hidden'
                      }}
                    >
                      <img
                        src={
                          !uploadImage
                            ? `${ip}${editedData[currentlyEditingRowId]?.Logo?.data?.attributes?.url}`
                            : URL.createObjectURL(uploadImage)
                        }
                        style={{ width: '100%' }}
                      />
                    </div>
                  </Stack>
                  <Stack justifyContent="center" spacing={8} style={{ marginTop: '10px' }}>
                    <button className="upload_img">
                      <input
                        type="file"
                        accept=".jpeg, .jpg"
                        onChange={e => {
                          const file = e.target.files[0];
                          if (!file || !["image/jpeg", "image/jpg"].includes(file.type)) {
                            return toaster.push(<Message showIcon type="error">Please select a JPEG or JPG image.</Message>);
                          }

                          const reader = new FileReader();
                          reader.onload = () => {
                            const img = new Image();
                            img.onload = () => {
                              const { width, height } = img;
                              if (width >= 150 && width <= 200 && height >= 150 && height <= 200) {
                                setUploadImage(file);
                                toaster.push(<Message showIcon type="success">Image upload successfully.</Message>);
                              } else {
                                toaster.push(<Message showIcon type="error">Image must be (150 x 150)px to (200 x 200)px.</Message>);
                              }
                            };
                            img.src = reader.result;
                          };
                          reader.readAsDataURL(file);
                        }}
                      />
                      <p>Upload</p>
                    </button>

                  </Stack>
                </FlexboxGrid.Item>
                <FlexboxGrid justify="start">
                  <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                    <Form.ControlLabel>Company Name</Form.ControlLabel>
                    <Input
                      value={editedData[currentlyEditingRowId]?.cmpnm || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'cmpnm', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>Address</Form.ControlLabel>
                    <Input
                      value={editedData[currentlyEditingRowId]?.address || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'address', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    as={Col}
                    colspan={24}
                    md={6}
                    className="cmpy-slt"
                    style={{ zIndex: '9999' }}
                  >
                    <Form.ControlLabel>Country</Form.ControlLabel>
                    <InputPicker
                      data={country}
                      value={editedData[currentlyEditingRowId]?.country || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'country', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>State</Form.ControlLabel>
                    <InputPicker
                      data={states}
                      value={editedData[currentlyEditingRowId]?.state || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'state', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                    <Form.ControlLabel>City</Form.ControlLabel>
                    <Input
                      value={editedData[currentlyEditingRowId]?.city || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'city', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>Pin No.</Form.ControlLabel>
                    <InputNumber
                      step={null}
                      value={editedData[currentlyEditingRowId]?.pin_no || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'pin_no', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>Reg. Type</Form.ControlLabel>
                    <InputPicker
                      data={regtype}
                      value={editedData[currentlyEditingRowId]?.reg_type || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'reg_type', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>Org. Type</Form.ControlLabel>
                    <InputPicker
                      data={orgtype}
                      value={editedData[currentlyEditingRowId]?.org_type || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'org_type', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>Email</Form.ControlLabel>
                    <Input
                      value={editedData[currentlyEditingRowId]?.email_id || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'email_id', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>Website</Form.ControlLabel>
                    <Input
                      value={editedData[currentlyEditingRowId]?.website || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'website', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>GST No.</Form.ControlLabel>
                    <Input
                      value={editedData[currentlyEditingRowId]?.gstno || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'gstno', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Form.ControlLabel>Type</Form.ControlLabel>
                    <InputPicker
                      data={type}
                      value={editedData[currentlyEditingRowId]?.Type || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'Type', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginTop: '1rem' }}>
                    <Form.ControlLabel>IP Address</Form.ControlLabel>
                    <Input
                      value={editedData[currentlyEditingRowId]?.GLink || ''}
                      onChange={value =>
                        handleInputChangeCommaster(currentlyEditingRowId, 'GLink', value, 0)
                      }
                    />
                  </FlexboxGrid.Item>

                </FlexboxGrid>
                <Divider> Contact Updates</Divider>
                <Stack justifyContent="flex-end">
                  <Button appearance="subtle" active onClick={addNewContact}>
                    Add Contact
                  </Button>
                </Stack>
                {ensureAtLeastOneContactRow().map((contact, index) => (
                  <div key={index}>
                    <FlexboxGrid justify="start">
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>Name</Form.ControlLabel>
                        <Input
                          value={
                            editedData[currentlyEditingRowId]?.ContactDetail?.[index]?.Name || ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(currentlyEditingRowId, 'Name', value, index)
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>Mobile No</Form.ControlLabel>
                        <InputNumber
                          step={null}
                          value={
                            editedData[currentlyEditingRowId]?.ContactDetail?.[index]?.mobileno ||
                            ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(
                              currentlyEditingRowId,
                              'mobileno',
                              value,
                              index
                            )
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>Email</Form.ControlLabel>
                        <Input
                          value={
                            editedData[currentlyEditingRowId]?.ContactDetail?.[index]?.email || ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(currentlyEditingRowId, 'email', value, index)
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginTop: '20px' }}>
                        {/* Button to Remove Row */}
                        <IconButton
                          color="red"
                          appearance="primary"
                          icon={<TrashIcon />}
                          onClick={() => removeContactRow(index)}
                          disabled={ensureAtLeastOneContactRow().length === 1}
                        />
                      </FlexboxGrid.Item>
                    </FlexboxGrid>
                  </div>
                ))}

                <Divider> Bank Details Update</Divider>
                {ensureAtLeastOneBankRow().map((bank, index) => (
                  <div key={index}>
                    <FlexboxGrid justify="start">
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>Bank Name</Form.ControlLabel>
                        <Input
                          value={
                            editedData[currentlyEditingRowId]?.Bank_Detail?.[index]?.bankName || ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(
                              currentlyEditingRowId,
                              'bankName',
                              value,
                              index
                            )
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>Branch Name</Form.ControlLabel>
                        <Input
                          value={
                            editedData[currentlyEditingRowId]?.Bank_Detail?.[index]?.branchName ||
                            ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(
                              currentlyEditingRowId,
                              'branchName',
                              value,
                              index
                            )
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>IFSC Code</Form.ControlLabel>
                        <Input
                          value={
                            editedData[currentlyEditingRowId]?.Bank_Detail?.[index]?.ifsc_code || ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(
                              currentlyEditingRowId,
                              'ifsc_code',
                              value,
                              index
                            )
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>Account No.</Form.ControlLabel>
                        <InputNumber
                          step={null}
                          value={
                            editedData[currentlyEditingRowId]?.Bank_Detail?.[index]?.accountno || ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(
                              currentlyEditingRowId,
                              'accountno',
                              value,
                              index
                            )
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>Bank address</Form.ControlLabel>
                        <Input
                          value={
                            editedData[currentlyEditingRowId]?.Bank_Detail?.[index]?.bankaddress ||
                            ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(
                              currentlyEditingRowId,
                              'bankaddress',
                              value,
                              index
                            )
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Form.ControlLabel>Swift Code</Form.ControlLabel>
                        <Input
                          value={
                            editedData[currentlyEditingRowId]?.Bank_Detail?.[index]?.swiftcode || ''
                          }
                          onChange={value =>
                            handleInputChangeCommaster(
                              currentlyEditingRowId,
                              'swiftcode',
                              value,
                              index
                            )
                          }
                        />
                      </FlexboxGrid.Item>
                      {/* <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                        <Button
                          appearance="primary"
                          color="red"
                          onClick={() => removeBankRow(index)}
                          disabled={ensureAtLeastOneBankRow().length === 1}
                        >
                          Remove
                        </Button>
                      </FlexboxGrid.Item> */}
                    </FlexboxGrid>
                  </div>
                ))}

                {/* Button to Add New Bank */}
                {/* <Button appearance="primary" onClick={addNewBank}>
                  Add New Bank
                </Button> */}
              </Form>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button appearance="subtle" active onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button
            appearance="primary"
            color="cyan"
            onClick={() => handleSaveRow(currentlyEditingRowId)}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack.Item alignSelf="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">Company</h3>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Company</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack.Item>
        </Stack>
        <Divider style={{ marginTop: '-10px' }} />
        <Message type="info">
          <b>Company Details </b>
        </Message>
        <Panel>
          <FlexboxGrid justify="space-between">
            <FlexboxGrid.Item as={Col} colspan={24} md={16}>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.ControlLabel>
                    <Stack>
                      <p>Company Name</p>
                      <p style={{ color: 'red' }}>*</p>
                    </Stack>
                  </Form.ControlLabel>
                  <Input
                    id="cmpnm"
                    name="cmpnm"
                    value={data && data.cmpnm ? data.cmpnm : ' '}
                    onChange={value => handleInputChange('cmpnm', value, 0)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>Address</Form.ControlLabel>
                  <Input
                    id="address"
                    name="address"
                    value={data && data.address ? data.address : ' '}
                    onChange={value => handleInputChange('address', value, 0)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>Country</Form.ControlLabel>
                  <SelectPicker
                    id="country"
                    name="country"
                    value={data && data.country ? data.country : ''}
                    onChange={value => handleInputChange('country', value, 0)}
                    labelKey="label"
                    valueKey="value"
                    data={country}
                    block
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.ControlLabel>State</Form.ControlLabel>
                  <SelectPicker
                    id="state"
                    name="state"
                    value={data && data.state ? data.state : ''}
                    onChange={value => handleInputChange('state', value, 0)}
                    labelKey="label"
                    valueKey="value"
                    data={states}
                    block
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>City</Form.ControlLabel>
                  <Input
                    id="city"
                    name="city"
                    value={data && data.city ? data.city : ''}
                    onChange={value => handleInputChange('city', value, 0)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>PIN No.</Form.ControlLabel>
                  <InputNumber
                    step={null}
                    id="pin_no"
                    name="pin_no"
                    value={data && data.pin_no ? data.pin_no : ' '}
                    onChange={value => handleInputChange('pin_no', value, 0)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.ControlLabel>Registration Type</Form.ControlLabel>
                  <SelectPicker
                    id="reg_type"
                    name="reg_type"
                    value={data && data.reg_type ? data.reg_type : ''}
                    onChange={value => handleInputChange('reg_type', value, 0)}
                    data={regtype}
                    block
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>Organisation Type</Form.ControlLabel>
                  <SelectPicker
                    id="org_type"
                    name="org_type"
                    value={data && data.org_type ? data.org_type : ''}
                    onChange={value => handleInputChange('org_type', value, 0)}
                    data={orgtype}
                    block
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>Type</Form.ControlLabel>
                  <SelectPicker
                    id="Type"
                    name="Type"
                    value={data && data.Type ? data.Type : ''}
                    onChange={value => handleInputChange('Type', value, 0)}
                    data={type}
                    block
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '10px' }}>
                  <Form.ControlLabel>Email</Form.ControlLabel>
                  <Input
                    id="email_id"
                    name="email_id"
                    value={data && data.email_id ? data.email_id : ' '}
                    onChange={value => handleInputChange('email_id', value, 0)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.ControlLabel>Website</Form.ControlLabel>
                  <Input
                    id="website"
                    name="website"
                    value={data && data.website ? data.website : ' '}
                    onChange={value => handleInputChange('website', value, 0)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.ControlLabel>GST No.</Form.ControlLabel>
                  <Input
                    id="gstno"
                    name="gstno"
                    value={data && data.gstno ? data.gstno : ' '}
                    onChange={value => handleInputChange('gstno', value, 0)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.ControlLabel>Contact No.</Form.ControlLabel>
                  <InputNumber
                    step={null}
                    name="contactno"
                    value={data.contactno || ''}
                    onChange={value => handleInputChange('contactno', value, 0)}
                  />
                </FlexboxGrid.Item>

                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.ControlLabel>Client Link</Form.ControlLabel>
                  <Input
                    id="GLink"
                    name="GLink"
                    value={data && data.GLink ? data.GLink : ' '}
                    onChange={value => handleInputChange('GLink', value, 0)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.ControlLabel>Trade Fair Link</Form.ControlLabel>
                  <Input
                    id="tradeFairLink"
                    name="tradeFairLink"
                    value={data && data.tradeFairLink ? data.tradeFairLink : ' '}
                    onChange={value => handleInputChange('tradeFairLink', value, 0)}
                  />
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Stack justifyContent="center">
                <span style={{ fontSize: '10px', color: 'red' }}>
                  {' '}
                  Image size must be 2 MB or smaller.*
                </span>
              </Stack>
              <Stack justifyContent="center">
                <Uploader
                  onChange={handleImageUpload}
                  fileListVisible={false}
                  listType="picture"
                  accept=".jpeg, .jpg"
                  action={''}
                  onUpload={file => {
                    const extension = file.name.split('.').pop().toLowerCase();
                    if (extension === 'jpeg' || extension === 'jpg') {
                      setUploading(true);
                      const reader = new FileReader();
                      reader.onload = () => {
                        const img = new Image();
                        img.onload = () => {
                          console.log(file)
                          if (file?.blobFile?.size > 2 * 1024 * 1024) {
                            toaster.push(
                              <Message showIcon type="error">
                                Image size must be less than 2 MB.
                              </Message>,
                              { placement: 'topCenter' }
                            );
                            return;
                          }

                          // const width = img.width;
                          // const height = img.height;

                          // const minWidth = 150;
                          // const maxWidth = 200;
                          // const minHeight = 150;
                          // const maxHeight = 200;

                          // if (
                          //   width >= minWidth &&
                          //   width <= maxWidth &&
                          //   height >= minHeight &&
                          //   height <= maxHeight
                          // ) {
                          setFileInfo(reader.result);
                          // } else {
                          //   toaster.push(
                          //     <Message type="error">
                          //       Image dimensions should be between 150x150px and 200x200px
                          //     </Message>
                          //   );
                          // }
                        };
                        img.src = reader.result;
                      };
                      reader.readAsDataURL(file.blobFile);
                    } else {
                      toaster.push(
                        <Message type="error">Only JPEG and JPG formats are allowed</Message>
                      );
                    }
                  }}
                  onSuccess={(response, file) => {
                    setUploading(false);

                    // console.log(response);
                  }}
                  onError={file => {
                    setUploading(false);
                    previewFile(file.blobFile, value => {
                      setFileInfo(value);
                    });
                  }}
                >
                  <button style={{ width: 232, height: 196 }}>
                    {uploading && <Loader backdrop center />}
                    {fileInfo ? <img src={fileInfo} /> : <ImageIcon style={{ fontSize: 80 }} />}
                  </button>
                </Uploader>
              </Stack>
              <Stack justifyContent="center">
                <IconButton
                  size="md"
                  icon={<TrashIcon />}
                  onClick={() => setFileInfo(null)}
                  active
                />
              </Stack>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Panel>
        <Message type="info">
          <b>Contact Details</b>
        </Message>
        <Panel>
          {rows.map((row, index) => (
            <div style={{ marginBottom: '10px' }}>
              <FlexboxGrid justify="space-between">
                <FlexboxGrid.Item as={Col} colspan={24} md={16}>
                  <FlexboxGrid justify="space-between">
                    <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                      <FormControlLabel>Name</FormControlLabel>
                      <Input
                        placeholder="Name"
                        value={rows[index]?.Name || ''}
                        onChange={value => handleAddRowData('Name', value, index)}
                        name="Name"
                      />
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                      <FormControlLabel>Mobile No.</FormControlLabel>
                      <InputNumber
                        step={null}
                        placeholder="Mobile No."
                        onChange={value => handleAddRowData('mobileno', value, index)}
                        value={rows[index]?.mobileno || ''}
                        name="mobileno"
                      />
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                      <FormControlLabel>Email</FormControlLabel>
                      <Input
                        placeholder="Email"
                        value={rows[index]?.email || ''}
                        onChange={value => handleAddRowData('email', value, index)}
                        name="email"
                      />
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  {rows.length > 1 && (
                    <IconButton
                      active
                      style={{ marginTop: '20px' }}
                      onClick={() => handleDeleteRow1(index)}
                      icon={<TrashIcon />}
                    />
                  )}
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </div>
          ))}
          <Button active onClick={handleAddRow}>
            Add Row
          </Button>
        </Panel>
        <Message type="info">
          <b>Bank Details</b>
        </Message>
        <Panel>
          {data.Bank_Detail.map((material, index) => (
            <div key={index}>
              <FlexboxGrid justify="start">
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '10px' }}>
                  <Form.ControlLabel>Bank Name</Form.ControlLabel>
                  <Input
                    name="bankName"
                    value={material.bankName}
                    onChange={value =>
                      handleInputChange('Bank_Detail', { name: 'bankName', value: value }, index)
                    }
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.ControlLabel>Branch Name</Form.ControlLabel>
                  <Input
                    name="branchName"
                    value={material.branchName}
                    onChange={value =>
                      handleInputChange('Bank_Detail', { name: 'branchName', value: value }, index)
                    }
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.ControlLabel>IFSC Code</Form.ControlLabel>
                  <Input
                    name="ifsc_code"
                    value={material.ifsc_code}
                    onChange={value =>
                      handleInputChange('Bank_Detail', { name: 'ifsc_code', value: value }, index)
                    }
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.ControlLabel>Account No.</Form.ControlLabel>
                  <InputNumber
                    step={null}
                    name="accountno"
                    value={material.accountno}
                    onChange={value =>
                      handleInputChange('Bank_Detail', { name: 'accountno', value: value }, index)
                    }
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.ControlLabel>Address</Form.ControlLabel>
                  <Input
                    name="bankaddress"
                    value={material.bankaddress}
                    onChange={value =>
                      handleInputChange('Bank_Detail', { name: 'bankaddress', value: value }, index)
                    }
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.ControlLabel>Swift Code</Form.ControlLabel>
                  <Input
                    name="swiftcode"
                    value={material.swiftcode}
                    onChange={value =>
                      handleInputChange('Bank_Detail', { name: 'swiftcode', value: value }, index)
                    }
                  />
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </div>
          ))}
          <Stack justifyContent="flex-end">
            {
              modalOpen ? (
                <Button
                  appearance="primary"
                  color="cyan"
                  onClick={() => handleSaveRow(currentlyEditingRowId)}
                >
                  Update
                </Button>
              ) :
                (
                  <Button
                    appearance="primary"
                    color="cyan"
                    onClick={submit}
                    className="company-btn"
                    disabled={data1.length > 0}
                  >
                    Save
                  </Button>
                )
            }

          </Stack>
          <Divider>
            <b>Company Details</b>
          </Divider>
          <Table rowHeight={55} data={data1} height={400} rowKey="id" bordered cellBordered>
            <Table.Column width={60} align="center" fixed>
              <HeaderCell>
                <b>Sr.No.</b>
              </HeaderCell>
              <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
            </Table.Column>
            <Table.Column width={150} align="center" flexGrow={1}>
              <Table.HeaderCell>
                <b>Company Name</b>
              </Table.HeaderCell>
              <Table.Cell dataKey={'attributes.cmpnm'} />
            </Table.Column>
            <Table.Column width={150} align="center" flexGrow={1}>
              <Table.HeaderCell>
                <b>City</b>
              </Table.HeaderCell>
              <Table.Cell dataKey={'attributes.city'} />
            </Table.Column>
            <Table.Column width={150} align="center" flexGrow={1}>
              <Table.HeaderCell>
                <b>GST.No</b>
              </Table.HeaderCell>
              <Table.Cell dataKey={'attributes.gstno'} />
            </Table.Column>
            <Table.Column width={150} align="center" flexGrow={1}>
              <Table.HeaderCell>
                <b>Email</b>
              </Table.HeaderCell>
              <Table.Cell dataKey={'attributes.email_id'} />
            </Table.Column>
            <Table.Column width={100} fixed="right">
              <Table.HeaderCell>
                <b>Action</b>
              </Table.HeaderCell>
              <Table.Cell style={{ padding: '6px', gap: '10px' }}>
                {rowData => (
                  <>
                    <IconButton
                      size="sm"
                      icon={<EditIcon />}
                      active
                      onClick={() => handleEditRow(rowData)}
                      style={{ marginRight: '5px' }}
                    />
                    {/* <IconButton
                      size="sm"
                      icon={<TrashIcon />}
                      active
                      onClick={() => delet(rowData.id)}
                    /> */}
                  </>
                )}
              </Table.Cell>
            </Table.Column>
          </Table>
          {renderModalContent()}
        </Panel>

        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px',
            zIndex: 2
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default CompanyMaster;
